<template>
  <div class="discover-page">
    <swiper
      ref="videoSwiper"
      :options="swiperOption"
      class="video-swiper"
      @slide-change="onSlideChange"
    >
      <swiper-slide
        v-for="(item, index) in videoList"
        :key="index"
        class="video-slide"
      >
        <div class="video-card">
          <div class="video-content">
            <video 
              :ref="'video' + index"
              src="../../assets/4.mp4"
              :controls="false"
              class="video-player"
              preload="auto"
              :muted="isMuted"
              @click="togglePlay(index)"
              @play="onVideoPlay(index)"
              @pause="onVideoPause(index)"
              @touchstart.stop
              @touchmove.stop
              @touchend.stop
            ></video>
            <!-- 视频播放/暂停按钮 - 仅视频显示 -->
            <div 
              class="center-play-btn" 
              v-if="item.statuss === 0 && currentIndex === index && isPaused"
              @click="togglePlay(index)"
            >
              <span>▶</span>
            </div>
            
            <!-- 视频底部控制栏 - 仅视频显示 -->
            <div class="video-bottom" v-if="item.statuss === 0">
              <span class="video-desc">{{ item.desc }}</span>
              <div class="video-controls">
                <span class="control-text" @click.stop="toggleMute">{{isMuted ? '静音' : '音量'}}</span>
                <span class="control-text" @click.stop="fullscreen(index)">全屏</span>
              </div>
            </div>

            <!-- 直播底部状态栏 - 仅直播显示 -->
            <div class="live-bottom" v-if="item.statuss === 1">
              <button class="enter-live-btn">点击进入直播</button>
              <div class="live-badge">
                <span class="live-dot"></span>
                <span>直播中</span>
              </div>
              <span class="live-desc">{{ item.desc }}</span>
            </div>
          </div>

          <div class="interaction-sidebar">
            <div class="user-avatar-wrap">
              <img :src="item.avatar" class="user-avatar" alt="avatar" />
              <div class="follow-btn" @click="follow">+</div>
            </div>
            <div class="action-btn" @click="like(index)">
              <div class="btn-icon">
                <img src="../../assets/dz_H.png" class="ananiu" alt="like" />
              </div>
              <span class="btn-count">{{ item.likes }}</span>
            </div>
            <div class="action-btn" @click="favorite(index)">
              <div class="btn-icon">
                <img src="../../assets/sc_H.png" class="ananiu" alt="favorite" />
              </div>
              <span class="btn-count">{{ item.favorites }}</span>
            </div>
            <div class="action-btn" @click.stop="toggleComment">
              <div class="btn-icon">
                <img src="../../assets/pl_H.png" class="ananiu" alt="comment" />
              </div>
              <span class="btn-count">{{ item.comments }}</span>
            </div>
            <div class="action-btn" @click="share">
              <div class="btn-icon">
                <img src="../../assets/dz_H.png" class="ananiu" alt="share" />
              </div>
              <span class="btn-count">分享</span>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>

    <div v-if="showCommentPanel" class="comment-overlay" @click.self="closeComment">
      <div class="comment-panel">
        <div class="panel-header">
          <span class="panel-title">{{ commentList.length }}条评论</span>
          <i class="el-icon-close" @click="closeComment"></i>
        </div>
        <div class="comment-tips">
          <i class="el-icon-warning-outline"></i>
          <span>禁止发表不良言论，文明互动</span>
        </div>
        <div class="comment-list" ref="commentList">
          <div v-for="(msg, index) in commentList" :key="index" class="comment-item">
            <img :src="msg.avatar" class="comment-avatar" alt="avatar" />
            <div class="comment-main">
              <div class="comment-header">
                <span class="comment-name">{{ msg.name }}</span>
                <span class="comment-time">{{ msg.time }}</span>
              </div>
              <div class="comment-text">{{ msg.text }}</div>
              <div class="comment-actions">
                <span class="like-btn">
                  <i class="el-icon-star-off"></i>
                  {{ msg.likes }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <div class="input-box">
            <input v-model="commentInput" type="text" placeholder="说点什么..." @keyup.enter="sendComment" />
            <button class="btn-send" @click="sendComment">发送</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'DiscoverPage',
  components: { Swiper, SwiperSlide },
  data() {
    return {
      swiperOption: {
        direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 0,
        touchRatio: 1,
        simulateTouch: true,
        allowTouchMove: true,
        mousewheel: true,
        grabCursor: true
      },
      currentIndex: 0,
      isPaused: false,
      isMuted: true,
      videoList: [
        {
          videoUrl: '../../assets/4.mp4',
          desc: '今日份练习室记录哦~~',
          avatar: 'https://via.placeholder.com/50',
          likes: 1234,
          favorites: 1234,
          comments: 12,
          statuss:1
        },
        {
          videoUrl: '../../assets/4.mp4',
          desc: '舞蹈练习日常',
          avatar: 'https://via.placeholder.com/50',
          likes: 2345,
          favorites: 2345,
          comments: 23,
          statuss:0
        },
        {
          videoUrl: '../../assets/4.mp4',
          desc: '新舞来袭！',
          avatar: 'https://via.placeholder.com/50',
          likes: 3456,
          favorites: 3456,
          comments: 34,
          statuss:1
        }
      ],
      showCommentPanel: false,
      commentList: [
        { name: '甜甜', text: '好好听呀！', time: '2分钟前', avatar: 'https://via.placeholder.com/30', likes: 12 },
        { name: 'mo mo', text: '厉害厉害', time: '5分钟前', avatar: 'https://via.placeholder.com/30', likes: 8 },
        { name: '魔丸', text: '很专业', time: '10分钟前', avatar: 'https://via.placeholder.com/30', likes: 23 }
      ],
      commentInput: ''
    }
  },
  mounted() {
    this.playVideo(0)
  },
  methods: {
    getVideo(index) {
      const videos = this.$el.querySelectorAll('video')
      return videos[index]
    },
    playVideo(index) {
      const video = this.getVideo(index)
      if (video) {
        video.play().catch(e => console.log('自动播放被阻止:', e))
        this.currentIndex = index
        this.isPaused = false
      }
    },
    pauseVideo(index) {
      const video = this.getVideo(index)
      if (video) {
        video.pause()
        video.currentTime = 0
      }
    },
    onSlideChange() {
      const swiper = this.$refs.videoSwiper.$swiper
      const newIndex = swiper.activeIndex
      
      // 暂停所有视频
      this.videoList.forEach((_, i) => this.pauseVideo(i))
      
      // 播放当前视频
      this.playVideo(newIndex)
    },
    togglePlay(index) {
      const video = this.getVideo(index)
      if (!video) return
      
      if (video.paused) {
        video.play()
        this.isPaused = false
      } else {
        video.pause()
        this.isPaused = true
      }
      this.currentIndex = index
    },
    fullscreen(index) {
      const video = this.getVideo(index)
      if (video) {
        if (video.requestFullscreen) video.requestFullscreen()
        else if (video.webkitRequestFullscreen) video.webkitRequestFullscreen()
      }
    },
    toggleMute() {
      this.isMuted = !this.isMuted
      // 更新当前视频的静音状态
      const video = this.getVideo(this.currentIndex)
      if (video) {
        video.muted = this.isMuted
      }
    },
    onVideoPlay(index) {
      if (this.currentIndex === index) {
        this.isPaused = false
      }
    },
    onVideoPause(index) {
      if (this.currentIndex === index) {
        this.isPaused = true
      }
    },
    follow() {
      this.$emit('follow')
    },
    like(index) {
      this.videoList[index].isLiked = !this.videoList[index].isLiked
      this.$emit('like')
    },
    favorite(index) {
      this.videoList[index].isFavorited = !this.videoList[index].isFavorited
      this.$emit('favorite')
    },
    toggleComment() {
      this.showCommentPanel = true
    },
    closeComment() {
      this.showCommentPanel = false
    },
    share() {
      this.$emit('share')
    },
    sendComment() {
      if (!this.commentInput.trim()) return
      this.commentList.push({
        name: '我',
        text: this.commentInput,
        time: '刚刚',
        avatar: 'https://via.placeholder.com/30',
        likes: 0
      })
      this.commentInput = ''
      this.scrollToBottom()
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.commentList
        if (container) container.scrollTop = container.scrollHeight
      })
    }
  }
}
</script>

<style scoped lang="scss">
.discover-page {
  width: 100%;
  height: 100%;
  background: #f4f4f5;
  position: relative;
  overflow: hidden;
}

.video-swiper {
  width: 100%;
  height: 100%;

  .video-slide {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.video-card {
  width: 100%;
  height: 100%;
  max-width: 650px;
  position: relative;
  display: flex;
  gap: 12px;
  margin: 0 auto;
  padding: 12px;
  box-sizing: border-box;
}

.video-content {
  flex: 1;
  min-width: 0;
  height: 100%;
  border-radius: 8px;
  border: 1px solid #e3e5e7;
  position: relative;
  overflow: hidden;
  background: #000;

  .video-player {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .center-play-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 56px;
    height: 56px;
    background: rgba(0, 0, 0, 0.55);
    border: 1px solid rgba(255, 255, 255, 0.25);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;

    span {
      color: #fff;
      font-size: 22px;
      margin-left: 4px;
    }
  }

  .video-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.55) 0%, transparent 100%);

    .video-desc {
      color: #fff;
      font-size: 13px;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
    }

    .video-controls {
      display: flex;
      gap: 12px;
      align-items: center;

      .control-text {
        color: rgba(255, 255, 255, 0.9);
        font-size: 12px;
        cursor: pointer;
        padding: 4px 10px;
        background: rgba(0, 0, 0, 0.55);
        border-radius: 4px;
        transition: background-color 0.2s ease;

        &:hover {
          background: #fb7299;
        }
      }
    }
  }

  .live-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 0 16px 16px;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.55) 0%, transparent 100%);

    .live-badge {
      align-self: flex-start;
      display: flex;
      align-items: center;
      gap: 5px;
      margin-bottom: 8px;
      background: #fb7299;
      padding: 2px 8px;
      border-radius: 4px;

      .live-dot {
        width: 6px;
        height: 6px;
        background: #fff;
        border-radius: 50%;
        animation: blink 1s infinite;
      }

      span {
        color: #fff;
        font-size: 12px;
        line-height: 16px;
        background: transparent;
        padding: 0;
      }
    }

    .live-desc {
      color: #fff;
      font-size: 13px;
      margin-bottom: 10px;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
    }

    .enter-live-btn {
      align-self: center;
      padding: 10px 32px;
      background: #fb7299;
      border: none;
      border-radius: 6px;
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      margin-bottom: 12px;
      transition: background-color 0.2s ease;

      &:hover {
        background: #ff85ad;
      }
    }
  }

  @keyframes blink {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.3; }
  }
}

.interaction-sidebar {
  width: 64px;
  flex-shrink: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 32px;
  gap: 18px;

  .user-avatar-wrap {
    position: relative;
    margin-bottom: 10px;

    .user-avatar {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      border: 1px solid #e3e5e7;
      object-fit: cover;
    }

    .follow-btn {
      position: absolute;
      bottom: -7px;
      left: 50%;
      transform: translateX(-50%);
      width: 20px;
      height: 20px;
      background: #fb7299;
      border-radius: 50%;
      display: flex;
      color: #fff;
      font-size: 14px;
      line-height: 1;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: background-color 0.2s ease;

      &:hover {
        background: #ff85ad;
      }
    }
  }

  .action-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    cursor: pointer;

    .btn-icon {
      width: 44px;
      height: 44px;
      background: rgba(0, 0, 0, 0.45);
      border: 1px solid rgba(255, 255, 255, 0.2);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background-color 0.2s ease;

      &:hover {
        background: #fb7299;
        border-color: #fb7299;
      }

      .ananiu {
        width: 22px;
        height: 22px;
      }
    }

    .btn-count {
      color: #fff;
      font-size: 12px;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
    }
  }
}

.comment-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
}

.comment-panel {
  width: 400px;
  max-width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;

  .panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #e3e5e7;

    .panel-title {
      font-size: 14px;
      font-weight: 600;
      color: #18191c;
    }

    i {
      font-size: 16px;
      color: #9499a0;
      cursor: pointer;
      transition: color 0.2s ease;

      &:hover {
        color: #fb7299;
      }
    }
  }

  .comment-tips {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 12px;
    background: #fff7ea;
    border-bottom: 1px solid #f1f2f3;

    i {
      color: #f5a623;
      font-size: 14px;
    }

    span {
      font-size: 12px;
      color: #61666d;
    }
  }

  .comment-list {
    flex: 1;
    overflow-y: auto;
    padding: 12px 16px;

    .comment-item {
      display: flex;
      gap: 10px;
      margin-bottom: 16px;

      .comment-avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        border: 1px solid #e3e5e7;
        flex-shrink: 0;
      }

      .comment-main {
        flex: 1;
        min-width: 0;

        .comment-header {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 4px;

          .comment-name {
            font-size: 13px;
            color: #18191c;
            font-weight: 500;
          }

          .comment-time {
            font-size: 11px;
            color: #9499a0;
          }
        }

        .comment-text {
          font-size: 14px;
          color: #18191c;
          line-height: 1.5;
          margin-bottom: 6px;
        }

        .comment-actions {
          .like-btn {
            font-size: 12px;
            color: #9499a0;
            cursor: pointer;
            transition: color 0.2s ease;

            i {
              margin-right: 4px;
            }

            &:hover {
              color: #fb7299;
            }
          }
        }
      }
    }
  }

  .panel-footer {
    padding: 12px 16px;
    border-top: 1px solid #e3e5e7;
    background: #fff;

    .input-box {
      display: flex;
      gap: 10px;
      align-items: center;

      input {
        flex: 1;
        min-width: 0;
        padding: 10px 14px;
        border: 1px solid #e3e5e7;
        border-radius: 6px;
        font-size: 14px;
        outline: none;
        background: #fff;
        transition: border-color 0.2s ease;

        &:focus {
          border-color: #fb7299;
        }

        &::placeholder {
          color: #9499a0;
        }
      }

      .btn-send {
        padding: 10px 22px;
        background: #fb7299;
        border: none;
        border-radius: 6px;
        color: #fff;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: background-color 0.2s ease;

        &:hover {
          background: #ff85ad;
        }
      }
    }
  }
}
</style>